import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../lib/supabase';
import { SharedResultsInbox as InboxView } from '../../components/shared/SharedResultsInbox';
import { LoadingSpinner } from '../../components/LoadingSpinner';

export function PartnerSharedResultsInbox() {
  const navigate = useNavigate();
  const { user, isLoading: authLoading } = useAuth();
  const [partnerId, setPartnerId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { navigate('/login'); return; }

    supabase
      .from('partners')
      .select('id')
      .eq('user_id', user.id)
      .maybeSingle()
      .then(({ data }) => {
        if (!data) { navigate('/login'); return; }
        setPartnerId(data.id);
        setLoading(false);
      });
  }, [user, authLoading, navigate]);

  if (authLoading || loading || !partnerId) {
    return <LoadingSpinner message="Loading..." />;
  }

  return (
    <div className="min-h-screen freud-bg py-8 px-4 md:px-8">
      <div className="max-w-5xl mx-auto">
        <InboxView recipientType="partner" recipientId={partnerId} />
      </div>
    </div>
  );
}
